import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import AccountmasterViewPage from 'pages/accountmaster/View';
import BranchmasterViewPage from 'pages/branchmaster/View';
import EmpmasterViewPage from 'pages/empmaster/View';
import MembermasterViewPage from 'pages/membermaster/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const GoldloancontractListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/goldloancontract/view/${data.loanaccountno}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('goldloancontract/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/goldloancontract/edit/${data.loanaccountno}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('goldloancontract/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.loanaccountno) },
			icon: "pi pi-trash",
			visible: () => auth.canView('goldloancontract/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function AcClosedTemplate(data){
		if(data){
			return (
				<><Chip
    label={
    data.ac_closed === 1
            ? "🔴"
            : "🟢"
    }
    style={{
        backgroundColor:
        data.ac_closed === 1
                ? "#f44336"
                : "#4caf50",
        color: "#fff",
        fontWeight: "bold"
    }}
/></>
			);
		}
	}
	function LoanaccountnoTemplate(data){
		if(data){
			return (
				<Link to={`/goldloancontract/view/${data.loanaccountno}`}> { data.loanaccountno }</Link>
			);
		}
	}
	function MemberidTemplate(data){
		if(data){
			return (
				<>{data.memberid && <Button className="p-button-text" icon="pi pi-eye" label={$t('membermaster')} onClick={() => app.openPageDialog(<MembermasterViewPage isSubPage apiPath={`/membermaster/view/${data.memberid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{data.branchcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('branchmaster')} onClick={() => app.openPageDialog(<BranchmasterViewPage isSubPage apiPath={`/branchmaster/view/${data.branchcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function DisbursementdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.disbursementdate )}</>
			);
		}
	}
	function AcCodeTemplate(data){
		if(data){
			return (
				<>{data.ac_code && <Button className="p-button-text" icon="pi pi-eye" label={$t('accountmaster')} onClick={() => app.openPageDialog(<AccountmasterViewPage isSubPage apiPath={`/accountmaster/view/${data.ac_code}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function InsuStartBorTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.insu_start_bor )}</>
			);
		}
	}
	function InsuEndBorTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.insu_end_bor )}</>
			);
		}
	}
	function EmpcodeTemplate(data){
		if(data){
			return (
				<>{data.empcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('empmaster')} onClick={() => app.openPageDialog(<EmpmasterViewPage isSubPage apiPath={`/empmaster/view/${data.empcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function LenderImageTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.lender_image} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-goldloancontract`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">{$t('records')} <b>{ recordsPosition } {$t('of')} { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="goldloancontract/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="GoldloancontractListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('goldLoanList')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/goldloancontract/add`}>
                            <Button label={$t('addNewGoldloancontract')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="loanaccountno" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="ac_closed" header={$t('acClosed')} body={AcClosedTemplate} sortable={true} ></Column>
                                            <Column  field="loanaccountno" header={$t('loanAccountNo')} body={LoanaccountnoTemplate} sortable={true} ></Column>
                                            <Column  field="memberid" header={$t('memberId')} body={MemberidTemplate} sortable={true} ></Column>
                                            <Column  field="branchcode" header={$t('branchCode')} body={BranchcodeTemplate} sortable={true} ></Column>
                                            <Column  field="schemeid" header={$t('schemeid')}  sortable={true} ></Column>
                                            <Column  field="interestrate" header={$t('interestRate')}  sortable={true} ></Column>
                                            <Column  field="loanamount" header={$t('loanAmount')}  sortable={true} ></Column>
                                            <Column  field="loanpaymentamountdue" header={$t('emi')}  sortable={true} ></Column>
                                            <Column  field="loanterm" header={$t('loanTerm')}  sortable={true} ></Column>
                                            <Column  field="loanpaymentfrequency" header={$t('ffrequency')}  sortable={true} ></Column>
                                            <Column  field="disbursementdate" header={$t('disbursementDate')} body={DisbursementdateTemplate} sortable={true} ></Column>
                                            <Column  field="amountdisbursed" header={$t('amountDisbursed')}  sortable={true} ></Column>
                                            <Column  field="chequeno" header={$t('chequeno')}  sortable={true} ></Column>
                                            <Column  field="ac_code" header={$t('acCode')} body={AcCodeTemplate} sortable={true} ></Column>
                                            <Column  field="processingfee" header={$t('processingFee')}  sortable={true} ></Column>
                                            <Column  field="insurancefee" header={$t('insuranceFee')}  sortable={true} ></Column>
                                            <Column  field="policy_number_bor" header={$t('policyNumber')}  sortable={true} ></Column>
                                            <Column  field="name_insurance" header={$t('nameInsurance')}  sortable={true} ></Column>
                                            <Column  field="insu_start_bor" header={$t('insuStart')} body={InsuStartBorTemplate} sortable={true} ></Column>
                                            <Column  field="insu_end_bor" header={$t('insuEnd')} body={InsuEndBorTemplate} sortable={true} ></Column>
                                            <Column  field="date_closed" header={$t('dateClosed')}  sortable={true} ></Column>
                                            <Column  field="empcode" header={$t('empcode')} body={EmpcodeTemplate} sortable={true} ></Column>
                                            <Column  field="lender_image" header={$t('lenderImage')} body={LenderImageTemplate} sortable={true} ></Column>
                                            <Column  field="created_by" header={$t('createdBy')}  sortable={true} ></Column>
                                            <Column  field="checked_by" header={$t('checkedBy')}  sortable={true} ></Column>
                                            <Column  field="created_on" header={$t('createdOn')}  sortable={true} ></Column>
                                            <Column  field="updated_on" header={$t('updatedOn')}  sortable={true} ></Column>
                                            <Column  field="amort_type" header={$t('amortType')}  sortable={true} ></Column>
                                            <Column  field="outstandingprincipal" header={$t('outstandingprincipal')}  sortable={true} ></Column>
                                            <Column  field="first_emi_date" header={$t('firstEmiDate')}  sortable={true} ></Column>
                                            <Column  field="datecontractends" header={$t('datecontractends')}  sortable={true} ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
GoldloancontractListPage.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'goldloancontract',
	apiPath: 'goldloancontract/index',
	routeName: 'goldloancontractlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default GoldloancontractListPage;
